import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';

type ExcelPreviewProps = {
  blob: Blob | undefined;
};

const ExcelPreview: React.FC<ExcelPreviewProps> = ({ blob }) => {
  const [htmlTable, setHtmlTable] = useState('');

  useEffect(() => {
    if (!blob) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const arrayBuffer = e && e.target && e.target.result;

      try {
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const firstSheet = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheet];
        const html = XLSX.utils.sheet_to_html(worksheet);

        setHtmlTable(html);
      } catch (err) {
        console.error('Error parsing Excel Blob:', err);
        setHtmlTable('<p>Unable to preview Excel file.</p>');
      }
    };

    reader.readAsArrayBuffer(blob);
  }, [blob]);

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: htmlTable }} style={{ overflowX: 'auto' }} />
    </div>
  );
};

export default ExcelPreview;
